// OneDrive:IgnoreCodeCoverage

import * as ErrorHelper from '@ms/telemetry-manager/lib/ErrorHelper';
import { IQosErrorData } from '@ms/telemetry-manager/lib/ErrorHelper';

export { IQosErrorData };
export default ErrorHelper;
